module.exports = __webpack_public_path__ + "static/media/cashback.a4c349c5.png";